const constant = {
    REQ_AUTH_LOGIN_VERIFY_SEND: 'auth.login.verify.send',
    REQ_AUTH_LOGIN_BY_VERIFY: 'auth.login.verify.verify',
    REQ_WEIXIN_OPEN_ID_GET: 'weixin.get.openid',
    REQ_MEMBER_INFO_GET: 'member.info.get',
    REQ_MOVIE_CITY_LIST: "movie.city.list",
    REQ_MOVIE_COUNTY_LIST: 'movie.county.list',
    REQ_ORDER_PAY: 'member.order.pay',
};

export default constant;